import '@babel/polyfill/noConflict';
import './vendor/modernizr';
import objectFitImages from 'object-fit-images';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import 'whatwg-fetch';

import { LocatorMap } from './lib/locator-map';
import { AnimateObserver } from './lib/animate-observer';
import { Trigger } from './lib/trigger';
import { LazyLoad } from './lib/lazy-load';
import { Maps } from './lib/map';
import { Tabs } from './lib/tabs';
import { Slider } from './lib/slider';
import { Filters } from './lib/filters';
import { Modal } from './lib/modal';

import 'root-consent';
import 'root-consent/dist/js/plugins/google-analytics';
import 'root-consent/dist/js/plugins/google-tag-manager';

objectFitImages();

const Consent = rootConsent( 'body', {
    messageText: 'This website uses cookies to ensure you get the best experience on our website',
    approveLabel: 'OK',
    delay: 500,
    theme: 'dark',
    alwaysApproved: false,
} );

Consent.registerPlugin( 'google-tag-manager', {
    tagID: 'GTM-W6FGGS2',
    anonymizeIp: true
} );

const animate = new AnimateObserver();
animate.init();

const lazy = new LazyLoad();
lazy.init();

const tabs = new Tabs();
tabs.init();

const gallery = new Slider();
gallery.init();

const triggers = new Trigger();
triggers.init();

const filters = new Filters();
filters.init();

const modal = new Modal();
modal.init();

GoogleMapsApiLoader( {
    libraries: [ '' ],
    apiKey: 'AIzaSyDZtofDJfjGO83C-rls9tXogngJCbx6xWA',
} ).then( ( googleApi ) => {

    const maps = new Maps( googleApi );
    maps.init();

    const locatorMap = new LocatorMap( googleApi );
    locatorMap.init();

}, ( err ) => {
    console.error( err );
} );

const lazyImages = new LazyLoad();
lazyImages.init();

if ( 'serviceWorker' in navigator ) {
    window.addEventListener( 'load', () => {
        navigator.serviceWorker.register( '/sw.js' ).then( registration => {
            console.log( 'SW registered: ', registration );
        } ).catch( registrationError => {
            console.log( 'SW registration failed: ', registrationError );
        } );
    } );
}
